import { renderPopover_unstable } from '@fluentui/react-popover';
/**
 * Render the final JSX of TeachingPopover
 */ export const renderTeachingPopover_unstable = renderPopover_unstable;
